<script setup lang="ts">
import { ref } from "vue";

const props = defineProps({
  exec: { type: Function, required: true },
  timeout: { type: Number, required: false, default: 1000 },
  icon: { type: String, required: false },
});

enum IconState {
  Ready,
  Loading,
  Failed,
  Success,
}

// Refresh icon status
const state = ref<IconState>(IconState.Ready);

async function run() {
  try {
    state.value = IconState.Loading;
    await props.exec();
    state.value = IconState.Success;
  } catch {
    state.value = IconState.Failed;
  } finally {
    setTimeout(() => (state.value = IconState.Ready), props.timeout);
  }
}
</script>

<template>
  <button
    class="btn text-nowrap"
    :disabled="state !== IconState.Ready"
    @click="run"
  >
    <span
      v-if="state == IconState.Loading"
      class="spinner-border spinner-border-sm text-secondary"
      role="status"
    >
      <span class="visually-hidden"></span>
    </span>

    <span v-else-if="state == IconState.Success" class="text-success">
      <i class="bi-check-circle" />
    </span>

    <span v-else-if="state == IconState.Failed" class="text-danger">
      <i class="bi-x-circle" />
    </span>

    <span v-else-if="icon">
      <i :class="icon" />
    </span>

    <slot />
  </button>
</template>
